import { React } from 'react';
import { withTranslation } from 'react-i18next';
import { Col, Container, Image, Row } from 'react-bootstrap';

import PME from "../../assets/images/homepage/certification/PME_25.svg"
import iso9001 from "../../assets/images/homepage/certification/iso9001.svg"
import iso27001 from "../../assets/images/homepage/certification/iso27001.svg"
import DGERT from "../../assets/images/homepage/certification/DGERT.svg"

import iso9001_PDF from "../../assets/files/ISO_9001.pdf"
import iso27001_PDF from "../../assets/files/ISO_27001.pdf"

const Certifications = props => {

    return (
        <section className='Certifications'>
            <Container className='container-custom'>
                <Row className='p-0'>
                    <Col xs={12} sm={11} md={12} className='d-flex align-items-center justify-content-start flex-column flex-lg-row p-0'>
                        <div className='p-0 w-100 d-flex justify-content-center align-items-center'>
                            <Col xs={2} lg={1}>
                                <Image src={PME} alt={props.t("alt:homepage.certifications.PME")} />
                            </Col>
                            <Col xs={2} lg={1}>
                                <a target='_blank' rel="noreferrer" href={iso9001_PDF}>
                                    <Image src={iso9001} alt={props.t("alt:homepage.certifications.iso9001")} />
                                </a>
                            </Col>
                            <Col xs={2} lg={1}>
                                <a target='_blank' rel="noreferrer" href={iso27001_PDF}>
                                    <Image src={iso27001} alt={props.t("alt:homepage.certifications.iso27001")} />
                                </a>
                            </Col>
                            <Col xs={2} lg={1}>
                                <Image src={DGERT} alt={props.t("alt:homepage.certifications.dgert")} />
                            </Col>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default withTranslation()(Certifications);